import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Text } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { SUBMIT_SUPPLIER_REVIEW } from "./graphql";

const ConfirmReviewView = ({ step, result, hide }) => {
  const [remark, setRemark] = useState("");
  const [submit, submitRes] = useMutation(SUBMIT_SUPPLIER_REVIEW, {
    onCompleted() {
      Alert("success", "Submit successfully!");
      hide();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_SUPPLIER_FOR_ONBOARDING"],
    awaitRefetchQueries: true,
  });

  return (
    <div>
      <div>
        {result === "ACCEPTED" && (
          <div>
            <p>
              You are about to <b>Accept</b> the review for step{" "}
              <b>{step.name}</b>.
            </p>
            <p> Please confirm your action.</p>
          </div>
        )}

        {result === "REJECTED" && (
          <div>
            <p>
              You are about to <b>Reject</b> the review for step{" "}
              <b>{step.name}</b>.
            </p>
          </div>
        )}

        <Text
          className="mt-4"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Optional remark for the review"
        />
      </div>

      <div className="flex space-x-6 mt-4">
        <Button
          onClick={() =>
            submit({ variables: { stepId: step.id, result, remark } })
          }
          primary
          loading={submitRes.loading}
        >
          Confirm
        </Button>
        <Button onClick={hide}>Cancel</Button>
      </div>
    </div>
  );
};

export default ConfirmReviewView;
